export default __webpack_public_path__ + "static/media/Learning-Paths-Logo-Wide.09a2e38f.png";